import {useEffect, useState} from "react";
import {findMollieSettlementsWithPagination} from "../api/eventGroupApiClient";

export const useMollieSettlements = (fromDate, toDate, page, pageSize, reloadTrigger) => {
    const [settlements, setSettlements] = useState([]);
    const [pagination, setPagination] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const abortController = new AbortController();
        setIsLoading(true);

        const settlementsWithPagination = findMollieSettlementsWithPagination(page, pageSize, fromDate, toDate, abortController.signal);

        settlementsWithPagination
            .then(
                (data) => {
                    const settlements = data.settlements;
                    const pagination = data.pagination;

                    setSettlements(settlements)
                    setPagination(pagination)
                    setIsLoading(false)
                }
            )
            .catch(
                (error) => {
                    if (abortController.signal.aborted) {
                        return;
                    }

                    console.log(error);
                    setIsLoading(false);
                }
            );

        return () => {
            abortController.abort();
        };
    }, [fromDate, toDate, page, pageSize, reloadTrigger]);

    return {settlements : settlements, pagination, isLoading};
};
